
import Vue from "vue";
import { mapState } from "vuex";
import { dispatch } from "@/store";

export default Vue.extend({
  data() {
    return {
      loading: false,
      time: 0,
      code: "",
      email: "",
      password: "",
      weChatSignInQRVisible: false,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("account", {
      privateKey: "privateKey",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    sendText(): string {
      if (this.time) {
        return "" + this.time + this.$t("resend");
      }
      return "" + this.$t("sendCode");
    },
    emailHelp(): string {
      if (this.email && !/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(this.email)) {
        return "" + this.$t("inputError") + this.$t("email");
      }
      return "";
    },
  },
  methods: {
    onSendCode() {
      const { email, time } = this;
      if (this.emailHelp) {
        return false;
      } else if (!time) {
        dispatch
          .appSendEmail(email)
          .then(() => {
            this.$message.info("" + this.$t("sendCaptchaCodeSuccess"));
            this.time = 59;
            const timer = setInterval(() => {
              this.time = this.time - 1;
              if (this.time <= 1) {
                clearInterval(timer);
                this.time = 0;
              }
            }, 1000);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    onEmailSignIn() {
      if (!this.email || this.emailHelp) {
        this.$message.info("" + this.$t("inputError") + this.$t("email"));
        return false;
      } else if (!this.code) {
        this.$message.info("" + this.$t("inputError") + this.$t("CAPTCHA"));
        return false;
      } else if (!this.password) {
        this.$message.info("" + this.$t("inputError") + this.$t("password"));
        return false;
      }
      this.loading = true;
      dispatch
        .appEmailSignUp({
          email: this.email,
          code: this.code.trim(),
          password: this.password,
        })
        .then(this.afterSignUp)
        .catch(() => {
          this.loading = false;
        });
    },
    afterSignUp() {
      this.$message.info("" + this.$t("signUpSuccess"));
      setTimeout(this.onSignIn, 2000);
    },
    onSignIn() {
      this.$router.push({
        path: this.$paths.root,
        query: this.$route.query,
      });
    },
  },
});
